<template>
  <div id="modal-calc-dealer" class="modal modal_callback" style="display: none;">
    <div v-if="isThanks" class="modal__inner">
      <div class="h2 m-b-s">
        Готово!
      </div>
      <p>
        Счет сформирован в <a href="https://order.promet.ru:8043" class="link">Личном кабинете дилера Промет</a>
      </p>
    </div>
    <div v-else class="modal__inner">
      <div class="h2 m-b-s">
        Выписать счет для дилера
      </div>
      <p>
        Внимание! В случае ввода неверного логина счет сформирован не будет.
      </p>
      <form class="form" @submit.prevent="submit" style="width: 451px;">
        <div class="field">
          <label class="field__label">Логин дилера</label>
          <div class="inp-wrap has-success">
            <input class="inp" :class="{valid: isWhoValid, error: !isWhoValid}" type="text" v-model="who">
            <span v-if="!isWhoValid" class="help-block form-error">* поле обязательно к заполнению</span>
          </div>
        </div>
        <div class="field">
          <label class="checkbox-wrap">
            <input type="checkbox" class="checkbox" v-model="checkrules">
            <span class="checkbox-imitator"></span>
            Ознакомлен с <a href="/legal/policy/" target="_blank" class="link-nb">правилами обработки персональных данных</a>
            <span v-if="!isCheckrulesValid" class="help-block form-error">Необходимо принять правила обработки персональных данных</span>
          </label>
        </div>
        <div class="field">
          <button type="submit" class="btn"><span>Отправить</span></button>
        </div>
      </form>
    </div>
  </div>
</template>

<script>
  export default {
    props: {
      pdfData: String,
    },
    data() {
      return {
        who: '',
        checkrules: false,
        isWhoValid: true,
        isCheckrulesValid: true,
        isThanks: false,
      };
    },
    methods: {
      validate() {
        this.isWhoValid = /.+/.test(this.who);
        this.isCheckrulesValid = this.checkrules;

        return (this.isWhoValid && this.isCheckrulesValid);
      },
      submit() {
        if (this.validate()) {
          const data = 'who=' + encodeURIComponent(this.who) + '&data=' + encodeURIComponent(this.pdfData);

          const xhr = new XMLHttpRequest();
          xhr.open('POST', process.env.VUE_APP_DEALER_URL);
          xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');
          xhr.onload = () => {
            this.isThanks = true;
          };
          xhr.send(data);
        }
      },
    },
  };
</script>

<style scoped>
  .inp.error {
    border-color: rgb(185, 74, 72);
  }
</style>